export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 31.264 31.263",
      url: __webpack_public_path__ + "img/icons.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }